import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ActionButton from '../action-button';

const ButtonsHeader = ({ isSticky = true, prevButton = null, nextButton = null }) => (
  <div
    className={classNames('ws-ui-buttons-header', {
      'ws-ui-buttons-header--sticky': isSticky,
    })}
  >
    <div className="ws-ui-buttons-header__container">
      <div className="ws-ui-buttons-header__button-wrapper">
        {prevButton && (
          <ActionButton
            format="text"
            iconGlyph={prevButton.iconGlyph || null}
            onClick={prevButton.onClick}
            label={prevButton.label}
            disabled={prevButton.disabled}
          />
        )}
      </div>

      <div className="ws-ui-buttons-header__button-wrapper">
        {nextButton && (
          <ActionButton
            format="text"
            iconGlyph={nextButton.iconGlyph || null}
            iconPlacement="after"
            onClick={nextButton.onClick}
            label={nextButton.label}
            disabled={nextButton.disabled}
          />
        )}
      </div>
    </div>
  </div>
);

ButtonsHeader.propTypes = {
  isSticky: PropTypes.bool,
  prevButton: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
    iconGlyph: PropTypes.string,
    disabled: PropTypes.bool,
  }),
  nextButton: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
    iconGlyph: PropTypes.string,
    disabled: PropTypes.bool,
  }),
};

export default ButtonsHeader;
